import { Link } from "react-router-dom";
import heroDesktop from "@/assets/hero-desktop.png";
import heroMobile from "@/assets/hero-mobile.jpg";
import footerBg from "@/assets/footer-bg.jpg";
import { CloudTrail } from "../components/CloudTrail";

export function Home() {
  return (
    <div className="bg-background min-h-screen flex flex-col">
      <div className="relative h-screen sm:h-auto xl:min-h-screen overflow-hidden">
        <CloudTrail />
        <img
          src={heroDesktop}
          alt="Jamie & Andrew"
          className="hidden sm:block mx-auto w-[108%] max-w-none pointer-events-none select-none -mt-[5%] -ml-[2%]"
        />
        <img
          src={heroMobile}
          alt="Jamie & Andrew"
          className="block sm:hidden mx-auto w-screen pointer-events-none select-none pb-6 pt-2 h-full object-contain"
        />
        <div className="absolute top-[90%] sm:top-[66%] left-1/2 -translate-x-1/2 -translate-y-1/2">
          <Link to="/rsvp" className="inline-block bg-transparent border-2 border-primary text-primary hover:bg-primary/10 rounded-full px-6 py-2 lg:px-10 lg:py-4 text-[1.175rem] xl:text-[1.5rem] xl:border-3 font-bold font-body tracking-wider transition-colors cursor-pointer">
            RSVP
          </Link>
        </div>
      </div>

      <div className="flex flex-col items-center text-center pb-8 sm:pt-8 px-8 space-y-4 flex-1">
        <div className="space-y-2">
          <h1 className="font-display font-normal">Jamie & Andrew</h1>
          <p className="text-muted-foreground">Friday, August 28, 2026</p>
          <p className="text-muted-foreground">Hood River, OR</p>
        </div>
        <div className="space-y-2">
          <p className="text-muted-foreground">Welcome Drinks · Thursday, August 27</p>
          <p className="text-muted-foreground">Ceremony & Reception · Friday, August 28</p>
        </div>
        <Link to="/schedule" className="font-body text-sm text-muted-foreground underline underline-offset-4 hover:text-foreground transition-colors">
          View full schedule
        </Link>
      </div>

      <img src={footerBg} alt="" className="w-full" />
    </div>
  );
}
